import type { components } from "@/lib/ApiSchema";
import { Tooltip } from "react-tooltip";
import PartThumbnail from "@/lib/PartThumbnail";

export default function RFQPartsTableCell({
  rfq,
}: {
  rfq: components["schemas"]["RfqListItemSchema"];
}) {
  const tooltipId = "partCount";
  return (
    <div className="flex gap-2 items-center">
      <Tooltip
        id={tooltipId}
        style={{
          fontSize: "10px",
          padding: "4px 8px",
          borderRadius: "4px",
        }}
      />
      <div
        className="border border-slate-300 w-8 rounded-3xl bg-slate-100 flex justify-center text-xs shrink-0"
        data-tooltip-id={tooltipId}
        data-tooltip-content={rfq.parts
          .map((part) => `${part.part_number} ${part.revision_number}`)
          .join(", ")}
      >
        {rfq.parts.length}
      </div>
      <div className="flex gap-1 overflow-x-auto">
        {rfq.parts.map((part, index) => {
          return (
            <div key={index} className="shrink-0">
              <Tooltip
                id={index.toString()}
                style={{
                  fontSize: "10px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                }}
              />
              <PartThumbnail
                url={part.thumbnail_url}
                className="border-[0.8px] border-slate-200 size-9 rounded-xs"
                data-tooltip-id={index.toString()}
                data-tooltip-content={`${part.part_number} ${part.revision_number}`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
